import React, { Component, Fragment, useState } from "react";
import "./Modals.scss";
import {
  modalService,
  modalPopup,
  logOutService,
} from "../../../services/subscriberService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { RowColoumn } from "../Row/Row";
import { Button } from "../Button/button";
import StreamingVideo from "../StreamingVideo/StreamingVideo";
import {
  UniqueID,
  CheckValue,
  CheckIfSpecialCharacter,
  getApprovedGyms,
} from "../../../services/CommonFunction";
import { staticVar } from "../../../services/Constants";
import { Dropdown } from "../Dropdown/Dropdown";
import {
  FieldGroup,
  FieldControl,
  Validators,
  FormBuilder,
} from "react-reactive-form";
import {
  FormGroupRow,
  FormGroups,
} from "../../ReusableComponents/FormGroups/FormGroups";
import {
  NumberTime,
  TextArea,
  RadioInput,
  CheckboxUIs,
  TextInput,
} from "../FormInput/FormInput";
import {
  changePassword,
  deleteAccount,
  gymInfo,
  linkGym,
  updateDefaultGym,
  updateGymLocations,
} from "../../../services/CallApi";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../../../store";
import OutsideAlerter from "../OutsideAlerter/OutsideAlerter";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

class Modals extends Component {
  state = {
    status: false,
    data: null,
  };

  componentDidMount() {
    this.modalSubscriber = modalService.getModalMessage().subscribe((res) => {
      this.setState({
        data: res.data,
        status: res.status,
      });
    });
  }

  componentWillUnmount() {
    this.modalSubscriber.unsubscribe();
  }

  render() {
    const status = this.state.status ? (
      <div className="Backdrop zIndex">
        <div className="historyModals">
          <OutsideAlerter
            className="modal_div"
            clickOutSide={() => {
              if (modalPopup.outside) {
                ClosePopup();
              }
            }}
          >
            {modalPopup.cross && (
              <div className="oval" onClick={() => ClosePopup()}>
                <FontAwesomeIcon icon={faTimes} />
              </div>
            )}
            {this.state.data}
          </OutsideAlerter>
        </div>
      </div>
    ) : null;

    return <React.Fragment>{status}</React.Fragment>;
  }
}

export const ModalB = (props) => (
  <div
    className={`modal-popUp blackB  ${props.class || ""}`}
    style={props.style}
  >
    {props.children}
  </div>
);

export const ModalBlack = (props) => (
  <div
    className={`modal-popUp blackBack  ${props.class || ""}`}
    style={props.style}
  >
    {props.children}
  </div>
);

export const ModalC = (props) => (
  <div className="modal-popUp blackC" style={props.style}>
    {props.children}
  </div>
);

export const ModalW = (props) => (
  <div className={`modal-popUp whiteB ${props.class}`}>{props.children}</div>
);

export const ModalReason = (props) => (
  <div className={`modal-popUp reason ${props.class}`}>{props.children}</div>
);

export const Modal = (props) => (
  <div className={`modal-popUp ${props.class}`}>{props.children}</div>
);

export const ModalHeader = (props) => (
  <div className="modal-header" style={props.style}>
    <span className="modal-header-title">{props.title}</span>
    {props.cross && (
      <div className="modal-header-cross">
        <FontAwesomeIcon
          onClick={() =>
            modalService.sendModalMessage({ status: false, data: null })
          }
          icon={faTimes}
        />
      </div>
    )}
  </div>
);

export const ModalBody = (props) => (
  <div className="modal-body" style={props.style}>
    {props.children}
  </div>
);

export const ModalFooter = (props) => (
  <div className="modal-footer" style={props.style}>
    {props.children}
  </div>
);

export const PopUpModal = (props) => {
  return (
    <ModalB>
      {/* <ModalHeader title="Link Video" /> */}
      <ModalBody>
        <p className="popup_text">
          {props.text || "Are you sure want to do this?"}
        </p>
        {props.note ? (
          <p className="popup_text_note">Note - {props.note}</p>
        ) : null}
        <RowColoumn style={{ justifyContent: "center" }}>
          <Button
            style={{ marginRight: "10px", minWidth: "150px" }}
            className="btns-default"
            label={props.cancelText || "cancel"}
            handleClick={props.close || ClosePopup}
          />
          <Button
            style={{ minWidth: "150px" }}
            handleClick={props.handleClick}
            className="btns-primary"
            label={props.submitText || "submit"}
          />
        </RowColoumn>
      </ModalBody>
    </ModalB>
  );
};

// export const PopUpModalWithNotes = (props) => {
//     return(
//         <ModalB>
//             {/* <ModalHeader title="Link Video" /> */}
//             <ModalBody>
//                 <p className="popup_text">{props.text || 'Are you sure want to do this?'}</p>
//                 {props.note?<p className="popup_text">{props.note}</p>:null}
//                 <RowColoumn style={{ justifyContent: 'center' }}>
//                     <Button style={{ marginRight: '10px', minWidth:'150px' }} className="btns-default" label={props.cancelText || "cancel"} handleClick={props.close || ClosePopup}/>
//                     <Button style={{ minWidth:'150px' }} handleClick={props.handleClick} className="btns-primary" label={props.submitText || "submit"} />
//                 </RowColoumn>
//             </ModalBody>
//         </ModalB>
//     )
// }

export const ClosePopup = () => {
  modalService.sendModalMessage({ status: false, data: null });
  modalPopup.cross = true;
  modalPopup.outside = false;
};

export const OpenPopup = (data, showCross = modalPopup.cross) => {
  if (CheckValue(data.props.videoSrc)) {
    modalPopup.cross = true;
  } else {
    modalPopup.cross = showCross;
  }
  modalService.sendModalMessage({ status: true, data: data });
};

export const VideoPopup = (props) => {
  return (
    <div className="video_modal">
      {/* {props.download?<a className="download" download={props.download} ><FontAwesomeIcon icon={faDownload} /></a>:null} */}

      <StreamingVideo
        {...props}
        videoSrc={props.download ? props.download : props.videoSrc}
        customPlayer={false}
      />
    </div>
  );
};
export const ErrorModals = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  let close = () => (props.close ? props.close() : null);
  let cancel = true;
  let cancelText = props.cancelText || "Ok";
  let cancelClass = props.cancelClass || "btns-default";
  let retry = props.retry;
  let msgs = props.text;
  let statusCode = 0;
  if (typeof props.text === "string") {
    if (
      props.text === "Try Again" ||
      props.text === "Connection terminated due to connection timeout"
    ) {
      cancel = false;
    }
  } else if (typeof props.text === "object") {
    if (props.text.data === undefined && props.text.message === undefined) {
      cancel = false;
      msgs = "Try Again";
    } else {
      msgs = props.text.message || props.text.data.message || "Try Again";
    }
    statusCode = props.text.statusCode || props.text.data.statusCode || 0;
  } else if (!CheckValue(props.text)) {
    cancel = false;
    msgs = "Try Again";
  }

  if (!retry) {
    cancelClass = props.cancelClass || "btns-primary";
  }
  if (statusCode === 401) {
    retry = false;
    cancelClass = "btns-primary";
    cancelText = "Ok";
    close = () => {
      localStorage.removeItem("setId");
      localStorage.removeItem("accessToken");
      dispatch(profileActions.reset());
      history.push({ pathname: "/SignIn" });
    };
  }

  return (
    <MainDivModal clas="errorModalUI">
      <div className="body">
        <span className="text">{msgs}</span>
        {props.note ? <span className="note">{props.note}</span> : null}
      </div>
      {/* <span className="text">Please enter the class duration to schedule without segments.</span> */}
      <div className="footer">
        {retry ? (
          <Button
            label={props.submitText || "Retry"}
            className={props.submitClass || "btns-primary"}
            handleClick={() => {
              modalPopup.cross = true;
              ClosePopup(true);
              props.retryData();
            }}
          />
        ) : null}
        {cancel ? (
          <Button
            label={cancelText}
            className={cancelClass}
            handleClick={() => {
              modalPopup.cross = true;
              close();
              ClosePopup(true);
              if (props.onOkay) {
                props.onOkay();
              }
            }}
          />
        ) : null}
      </div>
    </MainDivModal>
  );
};

const LocationSelectionList = ({
  locations,
  selectedLocations,
  updateSelectedLocations,
  allowMultipleSelect,
}) => {
  const locationUI = locations.map((el, index, arr) => {
    return (
      <Fragment key={el.value}>
        <CheckboxUIs
          label={el.name}
          value={selectedLocations.includes(el.value)}
          change={(e) => {
            if (e.target.checked) {
              if (!allowMultipleSelect) {
                updateSelectedLocations([el.value]);
              } else {
                updateSelectedLocations([...selectedLocations, el.value]);
              }
            } else {
              updateSelectedLocations(
                selectedLocations.filter((value) => value !== el.value)
              );
            }
          }}
          disabled={false}
        />
        {arr.length !== index + 1 ? (
          <span
            className={`divider${
              arr.length === index + 1 ? " transparent" : ""
            }`}
          ></span>
        ) : null}
      </Fragment>
    );
  });
  return <Fragment>{locationUI}</Fragment>;
};

export const LocationSelectionModal = ({
  gymID,
  locations,
  selectedLocations,
  allowMultipleSelect,
}) => {
  const [_selectedLocations, setSelectedLocations] =
    useState(selectedLocations);
  const dispatch = useDispatch();

  const update = () => {
    console.log(isEqual(_selectedLocations, selectedLocations));
    if (isEqual(_selectedLocations, selectedLocations)) {
      ErrorUI("Location updated successfully.");
    } else {
      updateGymLocations(gymID, _selectedLocations).then((response) => {
        if (response.status) {
          dispatch(profileActions.updateProfileData(response.data));
          ErrorUI("Location updated successfully.");
        } else {
          ErrorUI(response.list, () => update());
        }
      });
    }
  };
  return (
    <MainDivModal clas="errorModalUI joinStudioForm locationSelectModal">
      <div className="header">
        {allowMultipleSelect
          ? "You can select more than one location"
          : "Select a location"}
      </div>
      <div className="body">
        <LocationSelectionList
          locations={locations}
          selectedLocations={_selectedLocations}
          updateSelectedLocations={setSelectedLocations}
          allowMultipleSelect={allowMultipleSelect}
        />
      </div>
      <div className="footer">
        <Button
          disabled={!_selectedLocations.length}
          label={"Continue"}
          className={"btns-primary"}
          handleClick={() => {
            modalPopup.cross = true;
            ClosePopup(true);
            update();
          }}
        />
        <Button
          label={"Cancel"}
          className={"btns-default"}
          handleClick={() => {
            modalPopup.cross = true;
            ClosePopup(true);
          }}
        />
      </div>
    </MainDivModal>
  );
};

const isEqual = (a, b) => {
  console.log(a, b);
  let temp = true;
  a.forEach((el) => {
    if (!b.includes(el)) {
      temp = false;
    }
  });
  if (temp) {
    b.forEach((el) => {
      if (!a.includes(el)) {
        temp = false;
      }
    });
  }
  return temp;
};

export const OpenLocationSelectionModal = (
  gymID,
  locations,
  selectedLocations,
  allowMultipleSelect
) => {
  modalPopup.cross = false;
  OpenPopup(
    <LocationSelectionModal
      gymID={gymID}
      locations={locations}
      selectedLocations={selectedLocations}
      allowMultipleSelect={allowMultipleSelect}
    />
  );
};

export const JoinStudioModal = (props) => {
  const { gyms } = useSelector((state) => state.profile.profileData);
  const [membershipCode, setMembershipCode] = useState("");
  const [studio, setStudio] = useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const getStudioDetails = (code) => {
    gymInfo({ membership_code: code }).then((response) => {
      console.log(response);
      if (response.status) {
        const gymExists = gyms.find((gym) => {
          return (
            //todo: update this logic based on linked_status
            //gym.linked_status && gym.gym_id === response.data.gym_id
            false
          );
        });
        if (gymExists) {
          ErrorUI("You have already added this studio.");
        } else {
          setStudio(response.data);
        }
      } else {
        ErrorUI(response.list);
      }
    });
  };
  const dispatch = useDispatch();
  const linkStudio = () => {
    const data = { membership_code: membershipCode };
    if (studio.is_location_enabled) {
      if (selectedLocations.length === 0) {
        return;
      } else {
        data.selected_location_ids = selectedLocations;
      }
    }
    linkGym(data).then((response) => {
      if (response.status) {
        console.log(response);
        dispatch(profileActions.updateProfileData(response.data));
        ClosePopup(true);
      } else {
        ErrorUI(response.list, () => linkStudio());
      }
    });
  };
  const locations =
    studio && studio.is_location_enabled ? (
      <LocationSelectionList
        locations={studio.location_list}
        selectedLocations={selectedLocations}
        updateSelectedLocations={setSelectedLocations}
        allowMultipleSelect={studio.is_multiple_location_enabled}
      />
    ) : null;
  return (
    <MainDivModal clas="errorModalUI joinStudioForm">
      <div className="body">
        {studio ? (
          <Fragment>
            <img src={studio.logo_thumb} height={47} />
            <p>{studio.name}</p>
            {studio.is_location_enabled ? (
              <p>Please select a location:</p>
            ) : null}
            {locations}
          </Fragment>
        ) : (
          <Fragment>
            <p>Enter membership code:</p>
            <div className="form_group">
              <input
                type="text"
                className="formInput"
                autoFocus
                name="membershipCode"
                value={membershipCode}
                onChange={(e) => {
                  if (e.target.value && e.target.value.length < 9) {
                    setMembershipCode(e.target.value);
                  }
                }}
              />
            </div>
          </Fragment>
        )}
      </div>
      <div className="footer">
        <Button
          disabled={membershipCode.length !== 8}
          label={studio ? "Continue" : "Add Studio"}
          className={"btns-primary"}
          handleClick={() => {
            studio ? linkStudio() : getStudioDetails(membershipCode);
          }}
        />
        <Button
          label={"Cancel"}
          className={"btns-default"}
          handleClick={() => {
            modalPopup.cross = true;
            ClosePopup(true);
          }}
        />
      </div>
    </MainDivModal>
  );
};
export const OpenJoinStudioModal = () => {
  modalPopup.cross = false;
  OpenPopup(<JoinStudioModal />);
};

export const SelectStudioModal = (props) => {
  const dispatch = useDispatch();
  const { approvedGyms, defaultGym } = useSelector(
    (state) => state.profile.profileData
  );
  const onGymSelect = (gym) => {
    updateDefaultGym(gym.gym_id).then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData(res.data));
        modalPopup.cross = true;
        ClosePopup(true);
      } else {
        ErrorUI(res.list, () => {
          onGymSelect(gym);
        });
      }
    });
  };
  const gymsUI = getApprovedGyms(approvedGyms).map((gym, index) => {
    return (
      <a key={index} onClick={() => onGymSelect(gym)}>
        <div className="DropDownImageDiv">
          <img src={gym.logo_thumb} height={40} width={40} />
        </div>
        <p>{gym.name}</p>
      </a>
    );
  });
  return (
    <MainDivModal clas="errorModalUI SelectStudioModal">
      <div className="body">
        Please select a default studio:
        {gymsUI}
      </div>
    </MainDivModal>
  );
};

export const OpenStudioSelectModal = () => {
  modalPopup.cross = false;
  OpenPopup(<SelectStudioModal />);
};

export const ListModal = (props) => {
  let close = () => (props.close ? props.close() : null);
  let cancel = true;
  let cancelText = props.cancelText || "Ok";
  let cancelClass = props.cancelClass || "btns-default";
  let retry = props.retry;
  let msgs = props.text;
  const arymsgs = props.arymsgs
    ? props.arymsgs.map((el) => (
        <span className="modal_list_div_child">{el}</span>
      ))
    : null;
  let statusCode = 0;
  if (typeof props.text === "string") {
    if (
      props.text === "Try Again" ||
      props.text === "Connection terminated due to connection timeout"
    ) {
      cancel = false;
    }
  } else if (typeof props.text === "object") {
    if (props.text.data === undefined && props.text.message === undefined) {
      cancel = false;
      msgs = "Try Again";
    } else {
      msgs = props.text.message || props.text.data.message || "Try Again";
    }
    statusCode = props.text.statusCode || props.text.data.statusCode || 0;
  } else if (!CheckValue(props.text)) {
    cancel = false;
    msgs = "Try Again";
  }

  if (!retry) {
    cancelClass = props.cancelClass || "btns-primary";
  }
  if (statusCode === 401) {
    retry = false;
    cancelClass = "btns-primary";
    cancelText = "Ok";
    close = () => {
      logOutService.sendMessage("logout");
      logOutService.sendStopMessage("logout");
    };
  }

  return (
    <MainDivModal clas={`errorModalUI${arymsgs ? " modal_list" : ""}`}>
      <div className="body">
        <span className="text">{msgs}</span>
        {arymsgs ? <div className="modal_list_div">{arymsgs}</div> : null}
        {props.note ? <span className="note">{props.note}</span> : null}
      </div>
      {/* <span className="text">Please enter the class duration to schedule without segments.</span> */}
      <div className="footer">
        {retry ? (
          <Button
            label={props.submitText || "Retry"}
            className="btns-primary"
            handleClick={() => {
              modalPopup.cross = true;
              ClosePopup(true);
              props.retryData();
            }}
          />
        ) : null}
        {cancel ? (
          <Button
            label={cancelText}
            className={cancelClass}
            handleClick={() => {
              modalPopup.cross = true;
              close();
              ClosePopup(true);
            }}
          />
        ) : null}
      </div>
    </MainDivModal>
  );
};

export const ErrorModal = (props) => {
  return (
    <ModalW class="displayF">
      <ModalHeader title={props.title || "Error"} />
      <ModalBody>
        <p className="popup_text error">{props.text || "Error"}</p>
      </ModalBody>
      <ModalFooter>
        <div className="footer">
          {props.retry && (
            <div className="col text-right">
              <Button
                label={props.submitText || "Retry"}
                className="btns-primary"
                handleClick={props.retryData}
              />
              {/* <button className="btn btn-primary" onClick={props.retryData}>{props.submitText || "Retry"}</button> */}
            </div>
          )}
          <div className={props.retry ? "col text-left" : "col text-center"}>
            <Button
              label={props.cancelText || "Close"}
              className={props.cancelClass || "btns-default"}
              handleClick={props.close ? props.close : ClosePopup}
            />
            {/* <button className="btn btn-default" onClick={() => ClosePopup(true)}>{props.cancelText || "Close"}</button> */}
          </div>
        </div>
      </ModalFooter>
    </ModalW>
  );
};

export const OfflineModal = () => {
  return (
    <div className="Backdrop zIndex">
      <div className="historyModals">
        <div className="modal_div">
          <ModalW class="displayF">
            <ModalHeader title={"Error"} />
            <ModalBody>
              <p className="popup_text error">{"Internet not connected"}</p>
            </ModalBody>
            <ModalFooter>
              <div className="footer">
                <div className="col text-right">
                  <Button
                    label={"Retry"}
                    className="btns-primary"
                    handleClick={() => {
                      ClosePopup();
                      window.location.reload();
                    }}
                  />
                </div>
              </div>
            </ModalFooter>
          </ModalW>
        </div>
      </div>
    </div>
  );
};

export const SelectModal = (props) => {
  return (
    <ModalB class="selectModal">
      <ModalHeader
        title={`${props.value.length ? "Re-" : ""}${props.title || "Assign"}`}
      />
      <ModalBody>
        <Dropdown
          depend={false}
          showImage={props.showImage || true}
          id={UniqueID()}
          showOptionList={true}
          optionsList={props.list}
          handleOptionClick={props.click}
          selectedText={props.value}
        />
      </ModalBody>
    </ModalB>
  );
};

export const Errors = (msg, fun = null) => {
  OpenPopup(
    <ErrorModal
      text={msg || "Error"}
      retry={fun !== null}
      retryData={() => {
        ClosePopup();
        fun();
      }}
    />
  );
};
export const ErrorUI = (msg, fun = null, data = {}, onOkay = null) => {
  if (data.cross) {
    modalPopup.cross = data.cross;
  } else {
    modalPopup.cross = false;
  }
  OpenPopup(
    <ErrorModals
      text={msg}
      {...data}
      retry={fun !== null}
      retryData={() => {
        fun();
      }}
      onOkay={onOkay}
    />
  );
};
export const ErrorListUI = (msg, fun = null, data = {}) => {
  if (data.cross) {
    modalPopup.cross = data.cross;
  } else {
    modalPopup.cross = false;
  }
  OpenPopup(
    <ListModal
      text={msg}
      {...data}
      retry={fun !== null}
      retryData={() => {
        fun();
      }}
    />
  );
};

export const CreateTemplatePopup = (props) => {
  return (
    <ModalB class="templateModal">
      {/* <ModalHeader title="Link Video" /> */}
      <ModalBody>
        <p className="popup_text1">
          {props.text} {props.description || ""}
        </p>
        <RowColoumn style={{ justifyContent: "center" }}>
          <Button
            style={{ marginRight: "10px", minWidth: "150px" }}
            handleClick={() => props.handleClick(true)}
            className="btns-primary"
            label="OK"
          />
          <Button
            style={{ minWidth: "150px" }}
            handleClick={() => props.handleClick(false)}
            className="btns-default"
            label="Cancel"
          />
        </RowColoumn>
      </ModalBody>
    </ModalB>
  );
};

export const DurationModal = ({ form, duration, ...props }) => {
  return (
    <MainDivModal>
      <FieldGroup
        control={form.get("time")}
        render={({ get, invalid, touched }) => (
          <React.Fragment>
            <span className="text">
              Please enter the class duration to schedule without segments.
            </span>
            <FormGroupRow>
              <FormGroups>
                <FieldControl
                  name="hour"
                  render={NumberTime}
                  meta={{
                    label: `Hours`,
                    type: "NumberTime",
                    placeholder: "",
                    valid: false,
                  }}
                />
              </FormGroups>
              <FormGroups>
                <FieldControl
                  name="minute"
                  render={NumberTime}
                  meta={{
                    label: `Minutes`,
                    type: "NumberTime",
                    placeholder: "",
                    valid: false,
                  }}
                />
              </FormGroups>
              <FormGroups>
                <FieldControl
                  name="second"
                  render={NumberTime}
                  meta={{
                    label: `Seconds`,
                    type: "NumberTime",
                    placeholder: "",
                    valid: true,
                  }}
                />
              </FormGroups>
            </FormGroupRow>
            <span className="error">
              {touched &&
                get("total").hasError("min") &&
                `Minimum duration of the class should be at least 1 minute.`}
            </span>
            <FormFooterModal {...props} invalid={invalid} />
          </React.Fragment>
        )}
      />
    </MainDivModal>
  );
};

export const MainDivModal = (props) => (
  <div className={props.clas || "durationModal"}>{props.children}</div>
);
export const TextMotdal = (props) => <span className="text">{props.text}</span>;

export const FormFooterModal = ({ invalid, ...props }) => (
  <div className="footer">
    <Button
      label={props.cancelText || "Cancel"}
      className="btns-defaults"
      handleClick={() => (props.cancel ? props.cancel() : ClosePopup())}
    />
    <Button
      disabled={invalid}
      label={props.submitText || "Publish"}
      className="btns-primary"
      handleClick={props.submit}
    />
  </div>
);

export const UserStatusChangePopup = ({ title, submit, ...props }) => {
  const tempForm = FormBuilder.group({
    comment: ["", [Validators.required, Validators.minLength(3)]],
  });
  return (
    <MainDivModal clas="formModal">
      <ModalHeader title={title} />
      {/* <ModalHeader title="Reason for deactivate" /> */}
      <FieldGroup
        control={tempForm}
        render={({ get, invalid }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (!invalid) {
                submit(tempForm.value.comment);
              }
            }}
          >
            <FormGroups>
              <FieldControl
                name="comment"
                render={TextArea}
                meta={{
                  label: "",
                  rows: "5",
                  type: "text",
                  minLength: "3",
                  maxLength: 400,
                  placeholder: "",
                  valid: true,
                }}
              />
            </FormGroups>
            <FormFooterModal
              {...props}
              submitText="Submit"
              invalid={invalid}
              submit={() => submit(tempForm.value.comment)}
            />
          </form>
        )}
      />
    </MainDivModal>
  );
};

export const RecurringScheduleActivityModal = ({
  handleClick,
  text,
  ...props
}) => {
  const tempForm = FormBuilder.group({
    single: ["", Validators.required],
  });
  return (
    <MainDivModal clas="formModal">
      <ModalHeader
        title={
          text ||
          `This is a recurring ${staticVar.activity}. Do you wish to cancel?`
        }
      />
      {/* <ModalHeader title="Link Video" /> */}
      <FieldGroup
        control={tempForm}
        render={({ get, invalid }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (!invalid) {
                handleClick(tempForm.value.single);
              }
            }}
          >
            <FormGroups>
              <FieldControl
                name="single"
                render={RadioInput}
                meta={{
                  label: `This ${staticVar.activity}`,
                  type: "radio",
                  valid: true,
                  validation: true,
                }}
              />
            </FormGroups>
            <FormGroups>
              <FieldControl
                name="single"
                render={RadioInput}
                meta={{
                  label: `All ${staticVar.activity}`,
                  type: "radio",
                  valid: true,
                  validation: true,
                }}
              />
            </FormGroups>
            <FormFooterModal
              {...props}
              submitText="Yes"
              invalid={invalid}
              submit={() => handleClick(tempForm.value.single)}
            />
          </form>
        )}
      />
    </MainDivModal>
  );
};

export const ChangePasswordModal = (props) => {
  const changePWDForm = FormBuilder.group({
    oldPassword: ["", [Validators.required]],
    newPassword: [
      "",
      [Validators.required, Validators.minLength(10), CheckIfSpecialCharacter],
    ],
  });

  const handleSubmit = () => {
    if (changePWDForm.valid) {
      changePassword(changePWDForm.value).then((res) => {
        if (res.status) {
          ErrorUI("Your password has been changed.");
        } else {
          ErrorUI(res.list, () => OpenChangePasswordModal());
        }
      });
    }
  };
  return (
    <MainDivModal clas="errorModalUI ChangePWDModal">
      <FieldGroup
        control={changePWDForm}
        render={({ get, invalid }) => (
          <form onSubmit={handleSubmit}>
            <div className="body">
              <FormGroups>
                <FieldControl
                  name="oldPassword"
                  render={TextInput}
                  meta={{
                    label: "Password",
                    showLabel: false,
                    type: "password",
                    placeholder: "Old Password",
                    placeHolderIcon: "passwordInput",
                    minLength: "10",
                    maxLength: "50",
                    valid: true,
                    showError: true,
                  }}
                />
              </FormGroups>
              <FormGroups>
                <FieldControl
                  name="newPassword"
                  render={TextInput}
                  meta={{
                    label: "Password",
                    showLabel: false,
                    type: "password",
                    placeholder: "New Password",
                    placeHolderIcon: "passwordInput",
                    minLength: "10",
                    maxLength: "50",
                    valid: true,
                    showError: true,
                  }}
                />
              </FormGroups>
              {/* <div className="textDiv">
                <div className="validation_group">
                  <p style={{ color: "#979797" }}>Your password must:</p>
                  <CheckValid get={get} />
                </div>
              </div> */}
            </div>
            <div className="footer">
              <Button
                label={"Change Password"}
                className={"btns-primary"}
                disabled={invalid}
                handleClick={() => {
                  modalPopup.cross = true;
                  ClosePopup(true);
                  handleSubmit();
                }}
              />
              <Button
                label={"Cancel"}
                className={"btns-default"}
                handleClick={() => {
                  modalPopup.cross = true;
                  ClosePopup(true);
                }}
              />
            </div>
          </form>
        )}
      ></FieldGroup>
    </MainDivModal>
  );
};

export const OpenChangePasswordModal = () => {
  modalPopup.cross = false;
  OpenPopup(<ChangePasswordModal />);
};
export const DeleteAccountModal = (props) => {
  const dispatch = useDispatch();
  const { original, name } = useSelector((state) => state.profile.profileData);
  const [stage, setStage] = useState(0);

  const handleDeleteAccount = () => {
    if (pwdForm.valid) {
      deleteAccount(pwdForm.value).then((res) => {
        if (res.status) {
          dispatch(profileActions.updateProfileData(res.data));
          ErrorUI(
            "Your account deletion request has been forwarded to our support team. You can cancel this request anytime within 30 days."
          );
        } else {
          ErrorUI(res.list, () => OpenDeleteAccountModal());
        }
      });
    }
  };

  const pwdForm = FormBuilder.group({
    password: [
      "",
      [Validators.required, Validators.minLength(10), CheckIfSpecialCharacter],
    ],
  });

  const stageZeroUI = (
    <MainDivModal clas="errorModalUI DeleteAccountModal">
      <div className="body">
        <img src={original} alt="" height={124} width={124} />
        <p>{name}</p>
        <hr />
        <p>It’s sad to see you go.</p>
        <p>It will take us 30 days to permanently delete your account.</p>
        <p>
          We will not be able to recover any data of your account once it is
          deleted. You will not be able to access your class history, on demand
          activities or any information.
        </p>
        <p>
          Please reach out to our support team in case you are facing any issues
          and we will be in touch with you.
        </p>
      </div>
      <div className="footer">
        <a
          href={localStorage.getItem("supportLink")}
          target="_blank"
          onClick={() => {
            modalPopup.cross = true;
            ClosePopup(true);
          }}
        >
          <Button
            type="external"
            label={"Contact Support"}
            className={"btns-primary"}
          />
        </a>

        <Button
          label={"Continue"}
          className={"btns-default"}
          handleClick={() => {
            setStage(1);
          }}
        />
      </div>
    </MainDivModal>
  );
  const stageOneUI = (
    <MainDivModal clas="errorModalUI DeleteAccountModal">
      <div className="body">
        <img src={original} alt="" height={124} width={124} />
        <p>Enter password to confirm.</p>
        <hr />
        <FieldGroup
          control={pwdForm}
          render={({ get, invalid }) => (
            <form onSubmit={handleDeleteAccount}>
              <div className="body">
                <FormGroups>
                  <FieldControl
                    name="password"
                    render={TextInput}
                    meta={{
                      label: "Password",
                      showLabel: false,
                      type: "password",
                      placeholder: "Password",
                      placeHolderIcon: "passwordInput",
                      minLength: "10",
                      maxLength: "50",
                      valid: true,
                      showError: true,
                    }}
                  />
                </FormGroups>
              </div>
              <div className="footer">
                <Button
                  label={"Continue"}
                  className={"btns-primary"}
                  disabled={invalid}
                  handleClick={() => {
                    modalPopup.cross = true;
                    ClosePopup(true);
                    handleDeleteAccount();
                  }}
                />
                <Button
                  label={"Cancel"}
                  className={"btns-default"}
                  handleClick={() => {
                    modalPopup.cross = true;
                    ClosePopup(true);
                  }}
                />
              </div>
            </form>
          )}
        ></FieldGroup>
      </div>
    </MainDivModal>
  );
  return stage === 0 ? stageZeroUI : stageOneUI;
};
export const OpenDeleteAccountModal = () => {
  modalPopup.cross = false;
  modalPopup.outside = true;
  OpenPopup(<DeleteAccountModal />);
};

// const checkCond = async (form) => {
//     const value = form.value;
//     let temp = true;
//     await durationKey.forEach(el => {
//         if(parseInt(value[el]) > 0 && temp) {
//             temp = false;
//         }
//     });
//     return temp;
// }

export default Modals;
